export const SIDEBAR_CACHE_TTL_MS = 24 * 60 * 60 * 1000

export type SidebarCacheEnvelope<T> = {
  cachedAt: number
  expiresAt: number
  data: T
}

export function buildSidebarCacheEnvelope<T>(data: T, ttlMs = SIDEBAR_CACHE_TTL_MS): SidebarCacheEnvelope<T> {
  const now = Date.now()

  return {
    cachedAt: now,
    expiresAt: now + ttlMs,
    data
  }
}

export function readSidebarCacheValue<T>(
  envelope: unknown,
  validate: (value: unknown) => value is T
): T | null {
  if (!envelope || typeof envelope !== 'object') return null

  const parsed = envelope as Partial<SidebarCacheEnvelope<unknown>>
  const isEnvelopeValid
    = typeof parsed.cachedAt === 'number'
      && typeof parsed.expiresAt === 'number'
      && 'data' in parsed

  if (!isEnvelopeValid) return null

  // The 24-hour expiry is enforced through `expiresAt`. Once that moment has
  // passed, the caller should drop the cached sidebar payload and fetch fresh data.
  if (Date.now() >= parsed.expiresAt) {
    return null
  }

  if (!validate(parsed.data)) {
    return null
  }

  return parsed.data
}
